import {ADD_UPDATE_COMPANY_INFO_ACTION_TYPE, GET_ADD_UPDATE_COMPANY_INFO_DETAILS_ACTION_TYPE } from "../../utils/constants"


const initialState = [];

function companyInfoReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case ADD_UPDATE_COMPANY_INFO_ACTION_TYPE:
            return [...state, payload];
        case GET_ADD_UPDATE_COMPANY_INFO_DETAILS_ACTION_TYPE:
            return [...state, payload];
        default:
            return state;
    }
};

export default companyInfoReducer;